import FormInputError from "components/General/FormInputError";
import { PolicyLookUpWithSearchResultsModel } from "../ModalDialogs/PolicyLookUpWithSearchResultsModel";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import { useState, useEffect } from "react";

export default function PaymentPolicy({
  register,
  validate,
  getFieldState,
  errors,
  setCurrentStep,
  policy_Id,
  setValue,
  getValues,
  selectedPolicyId,
  setSelectedPolicyId,
  showPolicyLookup = true,
}) {
  // debounce function config
  let debounceFunction; //timer identifier
  let debounceTimer = 1500; //time in ms, 1.5 seconds for example
  const { t } = useTranslation();
  const policyNumId = uuidv4();
  const [isOpenPolicyLookup, setIsOpenPolicyLookup] = useState(false);

  useEffect(() => {
    if (policy_Id || selectedPolicyId) {
      setValue("policyNumber", policy_Id);
      setCurrentStep(2);
    }
  }, [policy_Id, selectedPolicyId]);

  return (
    <>
      <div className="ui-form-card-no-event">
        <label
          id={policyNumId + "-label"}
          htmlFor={policyNumId}
          className="block mb-1"
        >
          {t("AgentPaymentPolicy-policynumber")}
        </label>
        <input
          id={policyNumId}
          aria-labelledby={policyNumId + "-label"}
          disabled={true}
          aria-describedby={`${policyNumId + "-help"} ${
            policyNumId + "-error"
          }`}
          type="text"
          placeholder={t("AgentPaymentPolicy-selectpolicy-desc")}
          {...register("policyNumber", {
            // required: {
            //   value: true,
            //   message: "Please enter a valid policy number.",
            // },
            minLength: {
              value: 8,
              message: t(
                "AgentPolicyLookUpWithSearchResultsModel-policynumber"
              ),
            },
          })}
          onKeyUp={() => {
            clearTimeout(debounceFunction);
            debounceFunction = setTimeout(async () => {
              await validate("policyNumber");
              if (
                !getFieldState("policyNumber").invalid &&
                getValues("policyNumber") !== ""
              )
                setCurrentStep(2);
              else setCurrentStep(1);
            }, debounceTimer);
          }}
          onKeyDown={() => {
            clearTimeout(debounceFunction);
          }}
        />
        <div id={policyNumId + "-error"}>
          {errors.policyNumber?.message && (
            <FormInputError errorMessage={errors.policyNumber.message} />
          )}
        </div>
        <div
          id={policyNumId + "-help"}
          className="text-xxs text-theme-text-tertiary mt-1"
        >
          {/* Enter policy number as it appears in the customer policy */}
          {showPolicyLookup && (
            <div className="flex items-centers justify-start my-4">
              <button
                type="button"
                className="ui-btn-hyperlink ui-link-icon font-semibold"
                onClick={() => setIsOpenPolicyLookup(true)}
              >
                <svg
                  className="ui-icon w-4 h-4"
                  focusable="false"
                  aria-hidden="true"
                  role="presentation"
                >
                  <use href="#ui-icon-search"></use>
                </svg>
                {t("AgentPolicies-btn")}
              </button>
            </div>
          )}
        </div>
      </div>
      <PolicyLookUpWithSearchResultsModel
        isOpenPolicyLookup={isOpenPolicyLookup}
        setIsOpenPolicyLookup={setIsOpenPolicyLookup}
        setValue={setValue}
        setSelectedPolicyId={setSelectedPolicyId}
      />
    </>
  );
}
